import { render, staticRenderFns } from "./TrainingWatchLiveBanner.vue?vue&type=template&id=5fff9ffe"
import script from "./TrainingWatchLiveBanner.vue?vue&type=script&lang=js"
export * from "./TrainingWatchLiveBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports